const messages = {
  title: "Ceniki in brošure IZDELEK",
  title_media: "Ceniki in brošure IZDELEK",
  description:
    "Prenesite tukaj najnovejše brošure in letake o naših Bridgestone in Firestone pnevmatikah za osebna vozila, SUV-je in kombije.",
  short_description:
    "Tu lahko najdete podatke za družbene mreže, Instore-TV in več.",
  mediaCategories: {
    products: "Izdelki",
    brand_and_solutions: "Blagovna znamka in rešitve",
    season_and_promotions: "Sezona in promocije",
    format: "Format",
    cars_and_vans: "Avtomobil, SUV, Kombi",
    truck_and_buses: "Težka vozila in avtobusi",
    motorcycle: "Motocikel",
    agriculture: "Kmetijstvo",
    construction_machinery: "Gradbena mehanizacija",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiali",
    brochures: "Brošure izdelkov",
    price_list: "Ceniki",
    materials: "Materiali",
    video_in_store: "Video s podnapisi",
    video_online: "Video brez podnapisov",
    video: "Video",
    banner_website: "Pasica",
    banner_social_media: "Družbene mreže",
    logos: "Logotipi",
    summer: "Poletje",
    winter: "Zima",
    all_season: "Vse sezone",
    promotions: "Promocije",
    price: "Pricat",
  },
  mediasPage: {
    title: "MEDIJSKA KNJIŽNICA",
    description:
      "Dobrodošli v medijski sekciji, posvečeni   \n" +
      "Bridgestone in Firestone izdelkom.  \n <br> <br>" +
      "Odkriti boste vizualne prikaze izdelkov,   \n" +
      "logotipe, kot tudi široko izbiro   \n" +
      "pasi, video posnetkov in digitalnih materialov   \n" +
      "za uporabo na vaši spletni strani ali na   \n" +
      "družbenih mrežah.  ",
    bDrive: {
      title: "Fotografije izdelkov",
      description:
        "Trenutne slike   \n" +
        "lahko prenesete   \n" +
        "z našega B-\n" +
        "DRIVE portala.  ",
    },
  },
  buttons: {
    media: "ODKRIJ",
  },
  searchMedia: "Vnesite ključno besedo",
  searchResults: "Rezultati iskanja",
};

export default {
  messages,
};
